import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { formatDate } from '@angular/common';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-advt-stamp-register-report-component',
  templateUrl: './advt-stamp-register-report-component.component.html',
  styleUrl: './advt-stamp-register-report-component.component.scss'
})
export class AdvtStampRegisterReportComponentComponent implements OnInit {

  stampgetdata!: FormGroup;
  stampdata: any[] = [];
  reportType: string = 'Indetail';
  advtstampStartDate1: any;
  advtstampEndDate1: any;
  startDate: any;
  endDate: any;
  repName: any;
  offRepName: any;
  advtName: any;
  issueDates: any;
  issueDates1: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private service: DigisubservicesService
  ) {}

  // --------------------------------------------------
  // INIT
  // --------------------------------------------------
  ngOnInit(): void {
    this.createForm();

    // SET passed values inside form
    this.stampgetdata.patchValue({
      start: this.data.startDate,
      end: this.data.endDate,
      advtname: this.data.name,
      repName: this.data.repName,
      offRepName: this.data.offRepName,
      issueDates: this.data.issueDates
    });

    // AUTO CALL API
    this.getdateforstamp();

    debugger

     this.reportType = this.data['reportType'];
      this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
      this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
      this.repName = this.data['repName'];
      this.offRepName = this.data['offRepName'];
      this.advtName = this.data['name'];
      this.issueDates = this.data.issueDates;
      // this.issueDates1 = this.data['issue_date'];
  }


  

  // --------------------------------------------------
  // CREATE FORM
  // --------------------------------------------------
  createForm() {
    this.stampgetdata = this.fb.group({
      start: ['', Validators.required],
      end: ['', Validators.required],
      advtname: [''],
      repName: '',
      offRepName: '',
      issueDates :'',
    });
  }

  // --------------------------------------------------
  // FETCH DATA FROM API
  // --------------------------------------------------
  // getdateforstamp() {

  //   const startVal = this.stampgetdata.get('start')?.value;
  //   const endVal = this.stampgetdata.get('end')?.value;

  //   if (!startVal || !endVal) return; 

  //   const start_date = formatDate(startVal, 'yyyy-MM-dd', 'en-IN');
  //   const end_date = formatDate(endVal, 'yyyy-MM-dd', 'en-IN');
  //   const advt_name = this.stampgetdata.get('advtname')?.value || '';

  //    debugger

  //   this.service.getStampdata(start_date, end_date, advt_name).subscribe({
  //     next: (resp: any) => {
  //       console.log("Stamp Data =", resp);
  //       this.stampdata = resp || [];
  //     },
  //     error: (err) => console.error("API Error:", err)
  //   });
  // }


  getdateforstamp() {
  let startVal = this.stampgetdata.get('start')?.value;
  let endVal = this.stampgetdata.get('end')?.value;

  console.log("RAW START =", startVal);
  console.log("RAW END   =", endVal);

  if (!startVal || !endVal) return;


  

  // Convert and format correctly
  const start_date = formatDate(new Date(startVal), 'yyyy-MM-dd', 'en-IN');
  const end_date   = formatDate(new Date(endVal), 'yyyy-MM-dd', 'en-IN');
  const advt_name  = this.stampgetdata.get('advtname')?.value || "";
  const repName  = this.stampgetdata.get('repName')?.value || "";
   const offRepName  = this.stampgetdata.get('offRepName')?.value || "";
   const issueDates  = this.stampgetdata.get('issueDates')?.value || "";

  

  console.log("Formatted Start =", start_date);
  console.log("Formatted End   =", end_date);

  this.service.getStampdata1(
    start_date,
    end_date,
    advt_name,
    repName,
    offRepName,
    issueDates

)
.subscribe({
  next: (resp: any) => {
    console.log("Stamp Data Response =", resp);

    if (Array.isArray(resp)) {
      this.stampdata = resp;
    }
    else if (Array.isArray(resp?.data)) {
      this.stampdata = resp.data;
    }
    else if (Array.isArray(resp?.result)) {
      this.stampdata = resp.result;
    }
    else {
      this.stampdata = [];
    }

    console.log("Final Stampdata =", this.stampdata);
  },
  error: (err) => console.error("API Error:", err)
});

}



  // --------------------------------------------------
  // TOTAL
  // --------------------------------------------------
getTotalAmount() {
  return this.stampdata
    .reduce((sum, x) => sum + (Number(x.amt) || 0), 0)
    .toFixed(2);
}


exportExcel(fileName: string): void {
  const elt = document.getElementById('print-section') as HTMLTableElement | null;
  if (!elt) {
    console.error('Element with ID "print-section" not found');
    return;
  }

  // Convert table to sheet with raw parsing to preserve formats
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(elt, { raw: true });

  // Manually convert invoice date cells (dd/mm/yyyy) into actual Excel dates
  Object.keys(ws).forEach((addr) => {
    if (!addr.startsWith('!')) {
      const cell = ws[addr];
      const v = cell.v;
      if (typeof v === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(v)) {
        const [dd, mm, yyyy] = v.split('/').map(n => parseInt(n, 10));
        const date = new Date(yyyy, mm - 1, dd);
        date.setMilliseconds(0); // Prevent float rounding :contentReference[oaicite:1]{index=1}

        cell.t = 'd';
        cell.v = date;
        cell.z = 'dd/mm/yyyy';
      }
    }
  });

  // Create workbook and trigger download
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}


show = false

        printPageA3Portrait() {
      this.show = true;
      const printSection = document.getElementById('print-section');
      if (!printSection) {
          console.error("Print section not found!");
          return;
      }
    
      const printContent = printSection.innerHTML;
    
      const screenWidth = window.screen.availWidth;
  
      const windowWidth = 1000;
      const leftPosition = screenWidth - windowWidth - 50;
    
      const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
    
      
      if (printWindow) {
          printWindow.document.open();
        printWindow.document.write(`
  <html>
    <head>
      <title>Print Report</title>
      <style>
        @media print {
          @page { size: A3 landscape; margin: 5mm; }

          /* FIX DUPLICATE HEADER ISSUE */
          thead {
            display: table-row-group !important;
          }
          tfoot {
            display: table-row-group !important;
          }

          /* Your existing styles */
          table {
            border-collapse: collapse;
            width: auto !important;
          }
          th, td {
            border: 1px solid black !important;
            padding: 2px 3px !important;
            white-space: nowrap;
          }
          tr.header-row {
            display: table-header-group !important;
          }
          /* …and any other print styles you already have… */
        }
      </style>
    </head>
    <body>
      <div class="print-section">${printContent}</div>
      <script>
        window.onload = () => {
          const table = document.querySelector('table');
          if (!table) return console.error('Table not found');
          // Optional: column auto-sizing logic here…
          setTimeout(() => {
            window.print();
            setTimeout(() => window.close(), 500);
          }, 200);
        };
      </script>
    </body>
  </html>
`);

          printWindow.document.close();
      } else {
          console.error("Failed to open print window.");
      }
  }
       



}
